import { motion } from 'motion/react';
import { ScrollReveal } from '@/components/motion/scroll-reveal';
import { teamMembers } from '../data/about-data';

export function AboutTeam() {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <ScrollReveal className="text-center mb-16">
          <p className="text-sm font-semibold text-blue-600 dark:text-blue-400 tracking-wider uppercase mb-3">
            Nuestro Equipo
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Las personas detras de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-violet-600">
              Pricing Intelligence
            </span>
          </h2>
          <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
            Un equipo diverso de profesionales apasionados por la tecnologia, los datos y el impacto
            en los negocios de Latinoamerica.
          </p>
        </ScrollReveal>

        {/* Team grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="group relative rounded-xl border border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900/50 p-6 hover:border-blue-200 dark:hover:border-blue-500/30 shadow-sm hover:shadow-xl transition-all duration-300"
            >
              {/* Avatar */}
              <div className="flex items-center gap-4 mb-4">
                <div
                  className={`w-14 h-14 rounded-full bg-gradient-to-br ${member.gradient} flex items-center justify-center shadow-lg flex-shrink-0`}
                >
                  <span className="text-lg font-bold text-white">{member.initials}</span>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                    {member.name}
                  </h3>
                  <p className="text-sm text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-violet-600 font-medium">
                    {member.role}
                  </p>
                </div>
              </div>

              {/* Bio */}
              <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                {member.bio}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
